const RevenueSpendByAccountRevenueDetailsTableLangKey = [
	'column_date_click',
	'column_date_sale',
	'column_revenue',
	'column_offer',
	'column_sub_id',
	'column_sub_id_2',
	'column_campaign_group',
	'column_kt_group',
	'column_original_status',

] as const

type IRevenueSpendByAccountRevenueDetailsTableLangKey = typeof RevenueSpendByAccountRevenueDetailsTableLangKey[number]

export type IRevenueSpendByAccountRevenueDetailsTableLang = {
	revenue_spend_by_account_revenue_details_table: Record<IRevenueSpendByAccountRevenueDetailsTableLangKey, string>
}

const langEntries = RevenueSpendByAccountRevenueDetailsTableLangKey.map(
	(key: IRevenueSpendByAccountRevenueDetailsTableLangKey) => [key, `revenue_spend_by_account_revenue_details_table.${key}`]
)

const langObj: Record<IRevenueSpendByAccountRevenueDetailsTableLangKey, string> = Object.fromEntries(langEntries)

export const REVENUE_SPEND_BY_ACCOUNT_REVENUE_DETAILS_TABLE_LANG_KEY: IRevenueSpendByAccountRevenueDetailsTableLang = {
	revenue_spend_by_account_revenue_details_table: langObj
}
